import ENDPOINT from 'constants/endPoint';
import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

const endPoint = '/finances';

const financeApi = {
  async getFinances(payload) {
    const search = getParamsFormObject(payload);

    const path = endPoint + ENDPOINT.FINANCES_BOOKINGS + search;

    const response = await axiosClient.get(path);

    return response.data;
  },
  async getFinanceOverview(payload) {
    const search = getParamsFormObject(payload);

    const path = endPoint + ENDPOINT.FINANCES_OVERVIEW + search;

    const response = await axiosClient.get(path);

    return response.data;
  },
};

export default financeApi;
